<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'education'
    }
</script>

<style lang="scss" scoped>

</style>